const actions = {
  GET_SINGLE_SETTING_BEGIN: 'GET_SINGLE_SETTING_BEGIN',
  GET_SINGLE_SETTING_SUCCESS: 'GET_SINGLE_SETTING_SUCCESS',
  GET_SINGLE_SETTING_ERR: 'GET_SINGLE_SETTING_ERR',

  RESET_SINGLE_SETTING_DATA: 'RESET_SINGLE_SETTING_DATA',

  GET_ALL_SETTINGS_BEGIN: 'GET_ALL_SETTINGS_BEGIN',
  GET_ALL_SETTINGS_SUCCESS: 'GET_ALL_SETTINGS_SUCCESS',
  GET_ALL_SETTINGS_ERR: 'GET_ALL_SETTINGS_ERR',

  GET_ALL_COUNTRIES_BEGIN: 'GET_ALL_COUNTRIES_BEGIN',
  GET_ALL_COUNTRIES_SUCCESS: 'GET_ALL_COUNTRIES_SUCCESS',
  GET_ALL_COUNTRIES_ERR: 'GET_ALL_COUNTRIES_ERR',

  DELETE_SETTING_BEGIN: 'DELETE_SETTING_BEGIN',
  DELETE_SETTING_SUCCESS: 'DELETE_SETTING_SUCCESS',
  DELETE_SETTING_ERR: 'DELETE_SETTING_ERR',

  ADD_SETTING_BEGIN: 'ADD_SETTING_BEGIN',
  ADD_SETTING_SUCCESS: 'ADD_SETTING_SUCCESS',
  ADD_SETTING_ERR: 'ADD_SETTING_ERR',

  EDIT_SETTING_BEGIN: 'EDIT_SETTING_BEGIN',
  EDIT_SETTING_SUCCESS: 'EDIT_SETTING_SUCCESS',
  EDIT_SETTING_ERR: 'EDIT_SETTING_ERR',

  getSingleSettingBegin: () => {
    return {
      type: actions.GET_SINGLE_SETTING_BEGIN,
    };
  },

  getSingleSettingSuccess: (data) => {
    return {
      type: actions.GET_SINGLE_SETTING_SUCCESS,
      data,
    };
  },

  getSingleSettingErr: (err) => {
    return {
      type: actions.GET_SINGLE_SETTING_ERR,
      err,
    };
  },

  getAllCountriesBegin: () => {
    return {
      type: actions.GET_ALL_COUNTRIES_BEGIN,
    };
  },

  getAllCountriesSuccess: (data) => {
    return {
      type: actions.GET_ALL_COUNTRIES_SUCCESS,
      data,
    };
  },

  getAllCountriesErr: (err) => {
    return {
      type: actions.GET_ALL_COUNTRIES_ERR,
      err,
    };
  },

  getAllSettingsBegin: () => {
    return {
      type: actions.GET_ALL_SETTINGS_BEGIN,
    };
  },

  getAllSettingsSuccess: (data) => {
    return {
      type: actions.GET_ALL_SETTINGS_SUCCESS,
      data,
    };
  },

  getAllSettingsErr: (err) => {
    return {
      type: actions.GET_ALL_SETTINGS_ERR,
      err,
    };
  },

  addSettingBegin: () => {
    return {
      type: actions.ADD_SETTING_BEGIN,
    };
  },

  addSettingSuccess: (data) => {
    return {
      type: actions.ADD_SETTING_SUCCESS,
      data,
    };
  },

  addSettingErr: (err) => {
    return {
      type: actions.ADD_SETTING_ERR,
      err,
    };
  },

  deleteSettingBegin: () => {
    return {
      type: actions.DELETE_SETTING_BEGIN,
    };
  },

  deleteSettingSuccess: (data) => {
    return {
      type: actions.DELETE_SETTING_SUCCESS,
      data,
    };
  },

  deleteSettingErr: (err) => {
    return {
      type: actions.DELETE_SETTING_ERR,
      err,
    };
  },

  editSettingBegin: () => {
    return {
      type: actions.EDIT_SETTING_BEGIN,
    };
  },

  editSettingSuccess: (data) => {
    return {
      type: actions.EDIT_SETTING_SUCCESS,
      data,
    };
  },

  editSettingErr: (err) => {
    return {
      type: actions.EDIT_SETTING_ERR,
      err,
    };
  },

  resetSingleSettingData: () => {
    return {
      type: actions.RESET_SINGLE_SETTING_DATA,
    };
  },
};

export default actions;
